export default __webpack_public_path__ + "static/media/banner.4d409979.jpg";